import {
    A1_CONTENT,
    A12_ROWS,
    A13_FOOTER,
    A13_ROWS,
    A_PAGE_TITLES,
    A_SECTION_INDEX,
    A_SECTION_PAGES,
} from '@/pages/components/audit-program/a-section/constants';
import {
    B1_CONTENT,
    B21_PAGE,
    B22_PAGE,
    B3_PAGE,
    B4_PAGE,
    B5_PAGE,
    B6_PAGE,
    B61_PAGE,
    B62_PAGE,
    B7_PAGE,
    B8_PAGE,
    B81_PAGE,
    B_PAGE_TITLES,
    B_SECTION_INDEX,
    B_SECTION_PAGES_ALL,
} from '@/pages/components/audit-program/b-section/constants';
import {
    C1_CONTENT,
    C1A_CONTENT,
    C2_PAGE,
    C21_PAGE,
    C22_PAGE,
    C31_PAGE,
    C4_PAGE,
    C41_PAGE,
    C5_PAGE,
    C51_PAGE,
    C52_PAGE,
    C6_PAGE,
    C8_PAGE,
    C81_PAGE,
    C82_PAGE,
    C82_SEED_ROWS,
    C83_PAGE,
    C84_PAGE,
    C9_PAGE,
    C91_PAGE,
    C92_PAGE,
    C10_PAGE,
    C11_PAGE,
    C12_PAGE,
    C133_PAGE,
    C134_PAGE,
    C135_PAGE,
    CAPP01_PAGE,
    C_CHECKLIST_PAGES,
    C_PAGE_TITLES,
    C_SECTION_INDEX,
    C_SECTION_PAGES,
} from '@/pages/components/audit-program/c-section/constants';
import {
    D1_PAGE,
    D1_1_PAGE,
    D2_PAGE,
    D3_PAGE,
    D4_PAGE,
    D5_PAGE,
    D6_PAGE,
    D7_PAGE,
    D8_PAGE,
    D8_1_PAGE,
    D9_PAGE,
    D10_PAGE,
    D11_PAGE,
    D20_PAGE,
    D21_PAGE,
    D_PAGE_TITLES,
    D_SECTION_INDEX,
    D_SECTION_PAGES,
} from '@/pages/components/audit-program/d-section/constants';
import {
    E2_PAGE,
    EAPP01_PAGE,
    ES_PAGE,
    E_PAGE_TITLES,
    E_SECTION_INDEX,
    E_SECTION_PAGES,
} from '@/pages/components/audit-program/e-section/constants';
import {
    F2_PAGE,
    FAPP01_PAGE,
    FS_PAGE,
    F_PAGE_TITLES,
    F_SECTION_INDEX,
    F_SECTION_PAGES,
} from '@/pages/components/audit-program/f-section/constants';
import {
    G0_PAGE,
    G_PAGE_TITLES,
    G_SECTION_PAGES,
} from '@/pages/components/audit-program/g-section/constants';
import {
    H2_PAGE,
    HS_PAGE,
    H_PAGE_TITLES,
    H_SECTION_INDEX,
    H_SECTION_PAGES,
} from '@/pages/components/audit-program/h-section/constants';
import {
    I0_PAGE,
    I21_PAGE,
    I31_PAGE,
    I3_PAGE,
    I_PAGE_TITLES,
    I_SECTION_PAGES,
} from '@/pages/components/audit-program/i-section/constants';
import {
    J0_PAGE,
    J1_PAGE,
    J_1_PAGE,
    J_2_PAGE,
    J_PAGE_TITLES,
    J_SECTION_PAGES,
} from '@/pages/components/audit-program/j-section/constants';
import {
    K0_PAGE,
    K1_PAGE,
    K_1_PAGE,
    K_PAGE_TITLES,
    K_SECTION_PAGES,
} from '@/pages/components/audit-program/k-section/constants';
import {
    L1_PAGE,
    L2_PAGE,
    L4_PAGE,
    LAPP01_PAGE,
    LAPP02_PAGE,
    LAPP03_PAGE,
    LS_PAGE,
    L_PAGE_TITLES,
    L_SECTION_INDEX,
    L_SECTION_PAGES,
} from '@/pages/components/audit-program/l-section/constants';
import {
    M2_PAGE,
    MAPP01_PAGE,
    MS_PAGE,
    M_PAGE_TITLES,
    M_SECTION_INDEX,
    M_SECTION_PAGES,
} from '@/pages/components/audit-program/m-section/constants';
import {
    N2_PAGE,
    NAPP01_PAGE,
    NAPP02_PAGE,
    NS_PAGE,
    N_PAGE_TITLES,
    N_SECTION_INDEX,
    N_SECTION_PAGES,
} from '@/pages/components/audit-program/n-section/constants';
import {
    O0_PAGE,
    O1_PAGE,
    O2_PAGE,
    O_1_PAGE,
    O_PAGE_TITLES,
    O_SECTION_PAGES,
} from '@/pages/components/audit-program/o-section/constants';
import {
    P0_PAGE,
    P1_PAGE,
    P1_X1_PAGE,
    P_PAGE_TITLES,
    P_SECTION_PAGES,
} from '@/pages/components/audit-program/p-section/constants';
import {
    Q0_PAGE,
    Q1_2_PAGE,
    Q1_X11_PAGE,
    Q2_X11_PAGE,
    Q_PAGE_TITLES,
    Q_SECTION_PAGES,
} from '@/pages/components/audit-program/q-section/constants';
import {
    R0_PAGE,
    R0_1_PAGE,
    R1_PAGE,
    R2_PAGE,
    R3_PAGE,
    R4_PAGE,
    R5_PAGE,
    R6_PAGE,
    R7_PAGE,
    R8_PAGE,
    R9_PAGE,
    R10_PAGE,
    R11_PAGE,
    R12_PAGE,
    R13_PAGE,
    R_PAGE_TITLES,
    R_SECTION_PAGES,
} from '@/pages/components/audit-program/r-section/constants';
import {
    S2_PAGE,
    S3_PAGE,
    SS_PAGE,
    S_PAGE_TITLES,
    S_SECTION_INDEX,
    S_SECTION_PAGES,
} from '@/pages/components/audit-program/s-section/constants';
import {
    T2_PAGE,
    T2_2_PAGE,
    TS_PAGE,
    T04_PAGE,
    T05_PAGE,
    T06_PAGE,
    T07_PAGE,
    T08_PAGE,
    T09_PAGE,
    T_PAGE_TITLES,
    T_SECTION_PAGES,
} from '@/pages/components/audit-program/t-section/constants';
import {
    V1_PAGE,
    V2_PAGE,
    V2_1_PAGE,
    V3_PAGE,
    V4_1_PAGE,
    V_PAGE_TITLES,
    V_SECTION_PAGES,
} from '@/pages/components/audit-program/v-section/constants';
import {
    W2_PAGE,
    W3_PAGE,
    W3_1_PAGE,
    W4_PAGE,
    W5_PAGE,
    W6_PAGE,
    W7_PAGE,
    WS_PAGE,
    W_PAGE_TITLES,
    W_SECTION_INDEX,
    W_SECTION_PAGES,
} from '@/pages/components/audit-program/w-section/constants';
import {ALL_APPENDIX_DEFS} from '@/pages/components/audit-program/appendix';
import {
    X_SECTION_INDEX,
    X_SECTION_PAGES,
    Y_SECTION_INDEX,
    Y_SECTION_PAGES,
    Z_SECTION_INDEX,
    Z_SECTION_PAGES,
} from '@/pages/components/audit-program/xyz-section/constants';
import {
    PAF02_PAGE,
    PAF03_PAGE,
    PAF06_2_PAGE,
    PAF_PAGE_TITLES,
    PAF_PROGRAMMES,
    PAF_SECTION_INDEX,
    PAF_SECTION_PAGES,
    PAF_TABLES,
} from '@/pages/components/audit-program/paf-section/constants';
import {normalizeTemplateContent} from '@/pages/components/audit-program/templates/rowLevel';

export type ProgramTemplateKey = `${string}:${string}`;

export interface ProgramTemplatePageMeta {
    sectionCode: string;
    pageCode: string;
    title: string;
    /** memorandum | checklist | special */
    pageType: 'memorandum' | 'checklist' | 'special';
}

function clone<T>(value: T): T {
    return JSON.parse(JSON.stringify(value)) as T;
}

/** Code defaults keyed by `${sectionCode}:${pageCode}` — used as seed + FE fallback. */
export const PROGRAM_TEMPLATE_DEFAULTS: Record<string, Record<string, unknown>> = {
    'A:Ai': {title: A_PAGE_TITLES.Ai, rows: clone(A_SECTION_INDEX)},
    'A:A1': clone(A1_CONTENT) as unknown as Record<string, unknown>,
    'A:A1.2': {title: A_PAGE_TITLES['A1.2'], rows: clone(A12_ROWS)},
    'A:A1.3': {title: A_PAGE_TITLES['A1.3'], rows: clone(A13_ROWS), footer: clone(A13_FOOTER)},

    'B:Bi': {title: B_PAGE_TITLES.Bi, rows: clone(B_SECTION_INDEX)},
    'B:B1': clone(B1_CONTENT) as unknown as Record<string, unknown>,
    'B:B2.1': clone(B21_PAGE) as unknown as Record<string, unknown>,
    'B:B2.2': clone(B22_PAGE) as unknown as Record<string, unknown>,
    'B:B3': clone(B3_PAGE) as unknown as Record<string, unknown>,
    'B:B4': clone(B4_PAGE) as unknown as Record<string, unknown>,
    'B:B5': clone(B5_PAGE) as unknown as Record<string, unknown>,
    'B:B6': clone(B6_PAGE) as unknown as Record<string, unknown>,
    'B:B6.1': clone(B61_PAGE) as unknown as Record<string, unknown>,
    'B:B6.2': clone(B62_PAGE) as unknown as Record<string, unknown>,
    'B:B7': clone(B7_PAGE) as unknown as Record<string, unknown>,
    'B:B8': clone(B8_PAGE) as unknown as Record<string, unknown>,
    'B:B8.1': clone(B81_PAGE) as unknown as Record<string, unknown>,

    'C:Ci': {title: C_PAGE_TITLES.Ci, rows: clone(C_SECTION_INDEX)},
    'C:C1': clone(C1_CONTENT) as unknown as Record<string, unknown>,
    'C:C1a': clone(C1A_CONTENT) as unknown as Record<string, unknown>,
    'C:C2': clone(C2_PAGE) as unknown as Record<string, unknown>,
    'C:C2.1': clone(C21_PAGE) as unknown as Record<string, unknown>,
    'C:C2.2': clone(C22_PAGE) as unknown as Record<string, unknown>,
    'C:C3.1': clone(C31_PAGE) as unknown as Record<string, unknown>,
    'C:C4': clone(C4_PAGE) as unknown as Record<string, unknown>,
    'C:C4.1': clone(C41_PAGE) as unknown as Record<string, unknown>,
    'C:C5': clone(C5_PAGE) as unknown as Record<string, unknown>,
    'C:C5.1': clone(C51_PAGE) as unknown as Record<string, unknown>,
    'C:C5.2': clone(C52_PAGE) as unknown as Record<string, unknown>,
    'C:C6': clone(C6_PAGE) as unknown as Record<string, unknown>,
    'C:C7': {title: C_PAGE_TITLES.C7},
    'C:C7.1': {title: C_PAGE_TITLES['C7.1']},
    'C:C8': clone(C8_PAGE) as unknown as Record<string, unknown>,
    'C:C8.1': clone(C81_PAGE) as unknown as Record<string, unknown>,
    'C:C8.2': {...clone(C82_PAGE) as unknown as Record<string, unknown>, seedRows: clone(C82_SEED_ROWS)},
    'C:C8.3': clone(C83_PAGE) as unknown as Record<string, unknown>,
    'C:C8.4': clone(C84_PAGE) as unknown as Record<string, unknown>,
    'C:C9': clone(C9_PAGE) as unknown as Record<string, unknown>,
    'C:C9.1': clone(C91_PAGE) as unknown as Record<string, unknown>,
    'C:C9.2': clone(C92_PAGE) as unknown as Record<string, unknown>,
    'C:C10': clone(C10_PAGE) as unknown as Record<string, unknown>,
    'C:C11': clone(C11_PAGE) as unknown as Record<string, unknown>,
    'C:C12': clone(C12_PAGE) as unknown as Record<string, unknown>,
    'C:C13.3': clone(C133_PAGE) as unknown as Record<string, unknown>,
    'C:C13.4': clone(C134_PAGE) as unknown as Record<string, unknown>,
    'C:C13.5': clone(C135_PAGE) as unknown as Record<string, unknown>,
    'C:Capp01': clone(CAPP01_PAGE) as unknown as Record<string, unknown>,

    'D:Di': {title: D_PAGE_TITLES.Di, rows: clone(D_SECTION_INDEX)},
    'D:D1': clone(D1_PAGE) as unknown as Record<string, unknown>,
    'D:D1.1': clone(D1_1_PAGE) as unknown as Record<string, unknown>,
    'D:D2': clone(D2_PAGE) as unknown as Record<string, unknown>,
    'D:D3': clone(D3_PAGE) as unknown as Record<string, unknown>,
    'D:D4': clone(D4_PAGE) as unknown as Record<string, unknown>,
    'D:D5': clone(D5_PAGE) as unknown as Record<string, unknown>,
    'D:D6': clone(D6_PAGE) as unknown as Record<string, unknown>,
    'D:D7': clone(D7_PAGE) as unknown as Record<string, unknown>,
    'D:D8': clone(D8_PAGE) as unknown as Record<string, unknown>,
    'D:D8.1': clone(D8_1_PAGE) as unknown as Record<string, unknown>,
    'D:D9': clone(D9_PAGE) as unknown as Record<string, unknown>,
    'D:D10': clone(D10_PAGE) as unknown as Record<string, unknown>,
    'D:D11': clone(D11_PAGE) as unknown as Record<string, unknown>,
    'D:D20': clone(D20_PAGE) as unknown as Record<string, unknown>,
    'D:D21': clone(D21_PAGE) as unknown as Record<string, unknown>,

    'E:Ei': {title: E_PAGE_TITLES.Ei, rows: clone(E_SECTION_INDEX)},
    'E:Es': clone(ES_PAGE) as unknown as Record<string, unknown>,
    'E:E2': clone(E2_PAGE) as unknown as Record<string, unknown>,
    'E:Eapp01': clone(EAPP01_PAGE) as unknown as Record<string, unknown>,

    'F:Fi': {title: F_PAGE_TITLES.Fi, rows: clone(F_SECTION_INDEX)},
    'F:Fs': clone(FS_PAGE) as unknown as Record<string, unknown>,
    'F:F2': clone(F2_PAGE) as unknown as Record<string, unknown>,
    'F:Fapp01': clone(FAPP01_PAGE) as unknown as Record<string, unknown>,

    'G:G0': clone(G0_PAGE) as unknown as Record<string, unknown>,

    'H:Hi': {title: H_PAGE_TITLES.Hi, rows: clone(H_SECTION_INDEX)},
    'H:Hs': clone(HS_PAGE) as unknown as Record<string, unknown>,
    'H:H2': clone(H2_PAGE) as unknown as Record<string, unknown>,

    'I:I0': clone(I0_PAGE) as unknown as Record<string, unknown>,
    'I:I2-1': clone(I21_PAGE) as unknown as Record<string, unknown>,
    'I:I3': clone(I3_PAGE) as unknown as Record<string, unknown>,
    'I:I3-1': clone(I31_PAGE) as unknown as Record<string, unknown>,

    'J:J0': clone(J0_PAGE) as unknown as Record<string, unknown>,
    'J:J1': clone(J1_PAGE) as unknown as Record<string, unknown>,
    'J:J_1': clone(J_1_PAGE) as unknown as Record<string, unknown>,
    'J:J_2': clone(J_2_PAGE) as unknown as Record<string, unknown>,

    'K:K0': clone(K0_PAGE) as unknown as Record<string, unknown>,
    'K:K1': clone(K1_PAGE) as unknown as Record<string, unknown>,
    'K:K_1': clone(K_1_PAGE) as unknown as Record<string, unknown>,

    'L:Li': {title: L_PAGE_TITLES.Li, rows: clone(L_SECTION_INDEX)},
    'L:Ls': clone(LS_PAGE) as unknown as Record<string, unknown>,
    'L:L2': clone(L2_PAGE) as unknown as Record<string, unknown>,
    'L:L1': clone(L1_PAGE) as unknown as Record<string, unknown>,
    'L:L4': clone(L4_PAGE) as unknown as Record<string, unknown>,
    'L:Lapp01': clone(LAPP01_PAGE) as unknown as Record<string, unknown>,
    'L:Lapp02': clone(LAPP02_PAGE) as unknown as Record<string, unknown>,
    'L:Lapp03': clone(LAPP03_PAGE) as unknown as Record<string, unknown>,

    'M:Mi': {title: M_PAGE_TITLES.Mi, rows: clone(M_SECTION_INDEX)},
    'M:Ms': clone(MS_PAGE) as unknown as Record<string, unknown>,
    'M:M2': clone(M2_PAGE) as unknown as Record<string, unknown>,
    'M:Mapp01': clone(MAPP01_PAGE) as unknown as Record<string, unknown>,

    'N:Ni': {title: N_PAGE_TITLES.Ni, rows: clone(N_SECTION_INDEX)},
    'N:Ns': clone(NS_PAGE) as unknown as Record<string, unknown>,
    'N:N2': clone(N2_PAGE) as unknown as Record<string, unknown>,
    'N:Napp01': clone(NAPP01_PAGE) as unknown as Record<string, unknown>,
    'N:Napp02': clone(NAPP02_PAGE) as unknown as Record<string, unknown>,

    'O:O0': clone(O0_PAGE) as unknown as Record<string, unknown>,
    'O:O1': clone(O1_PAGE) as unknown as Record<string, unknown>,
    'O:O2': clone(O2_PAGE) as unknown as Record<string, unknown>,
    'O:O_1': clone(O_1_PAGE) as unknown as Record<string, unknown>,

    'P:P0': clone(P0_PAGE) as unknown as Record<string, unknown>,
    'P:P1': clone(P1_PAGE) as unknown as Record<string, unknown>,
    'P:P1.x1': clone(P1_X1_PAGE) as unknown as Record<string, unknown>,

    'Q:Q0': clone(Q0_PAGE) as unknown as Record<string, unknown>,
    'Q:Q1.x11': clone(Q1_X11_PAGE) as unknown as Record<string, unknown>,
    'Q:Q1.2': clone(Q1_2_PAGE) as unknown as Record<string, unknown>,
    'Q:Q2.x11': clone(Q2_X11_PAGE) as unknown as Record<string, unknown>,

    'R:R0': clone(R0_PAGE) as unknown as Record<string, unknown>,
    'R:R0.1': clone(R0_1_PAGE) as unknown as Record<string, unknown>,
    'R:R1': clone(R1_PAGE) as unknown as Record<string, unknown>,
    'R:R2': clone(R2_PAGE) as unknown as Record<string, unknown>,
    'R:R3': clone(R3_PAGE) as unknown as Record<string, unknown>,
    'R:R4': clone(R4_PAGE) as unknown as Record<string, unknown>,
    'R:R5': clone(R5_PAGE) as unknown as Record<string, unknown>,
    'R:R6': clone(R6_PAGE) as unknown as Record<string, unknown>,
    'R:R7': clone(R7_PAGE) as unknown as Record<string, unknown>,
    'R:R8': clone(R8_PAGE) as unknown as Record<string, unknown>,
    'R:R9': clone(R9_PAGE) as unknown as Record<string, unknown>,
    'R:R10': clone(R10_PAGE) as unknown as Record<string, unknown>,
    'R:R11': clone(R11_PAGE) as unknown as Record<string, unknown>,
    'R:R12': clone(R12_PAGE) as unknown as Record<string, unknown>,
    'R:R13': clone(R13_PAGE) as unknown as Record<string, unknown>,

    'S:Si': {title: S_PAGE_TITLES.Si, rows: clone(S_SECTION_INDEX)},
    'S:Ss': clone(SS_PAGE) as unknown as Record<string, unknown>,
    'S:S2': clone(S2_PAGE) as unknown as Record<string, unknown>,
    'S:S3': clone(S3_PAGE) as unknown as Record<string, unknown>,

    'T:Ts': clone(TS_PAGE) as unknown as Record<string, unknown>,
    'T:T2': clone(T2_PAGE) as unknown as Record<string, unknown>,
    'T:T2-2': clone(T2_2_PAGE) as unknown as Record<string, unknown>,
    'T:T04': clone(T04_PAGE) as unknown as Record<string, unknown>,
    'T:T05': clone(T05_PAGE) as unknown as Record<string, unknown>,
    'T:T06': clone(T06_PAGE) as unknown as Record<string, unknown>,
    'T:T07': clone(T07_PAGE) as unknown as Record<string, unknown>,
    'T:T08': clone(T08_PAGE) as unknown as Record<string, unknown>,
    'T:T09': clone(T09_PAGE) as unknown as Record<string, unknown>,

    'V:V1': clone(V1_PAGE) as unknown as Record<string, unknown>,
    'V:V2': clone(V2_PAGE) as unknown as Record<string, unknown>,
    'V:V2.1': clone(V2_1_PAGE) as unknown as Record<string, unknown>,
    'V:V3': clone(V3_PAGE) as unknown as Record<string, unknown>,
    'V:V4.1': clone(V4_1_PAGE) as unknown as Record<string, unknown>,

    'W:Wi': {title: W_PAGE_TITLES.Wi, rows: clone(W_SECTION_INDEX)},
    'W:Ws': clone(WS_PAGE) as unknown as Record<string, unknown>,
    'W:W2': clone(W2_PAGE) as unknown as Record<string, unknown>,
    'W:W3': clone(W3_PAGE) as unknown as Record<string, unknown>,
    'W:W3.1': clone(W3_1_PAGE) as unknown as Record<string, unknown>,
    'W:W4': clone(W4_PAGE) as unknown as Record<string, unknown>,
    'W:W5': clone(W5_PAGE) as unknown as Record<string, unknown>,
    'W:W6': clone(W6_PAGE) as unknown as Record<string, unknown>,
    'W:W7': clone(W7_PAGE) as unknown as Record<string, unknown>,

    'X:Xi': {title: 'Index', rows: clone(X_SECTION_INDEX)},
    'Y:Yi': {title: 'Index', rows: clone(Y_SECTION_INDEX)},
    'Z:Zi': {title: 'Index', rows: clone(Z_SECTION_INDEX)},

    'PAF:PAF01': {title: PAF_PAGE_TITLES.PAF01, rows: clone(PAF_SECTION_INDEX)},
    'PAF:PAF02': clone(PAF02_PAGE) as unknown as Record<string, unknown>,
    'PAF:PAF03': clone(PAF03_PAGE) as unknown as Record<string, unknown>,
    'PAF:PAF06.2': clone(PAF06_2_PAGE) as unknown as Record<string, unknown>,
    ...Object.fromEntries(
        Object.entries(PAF_PROGRAMMES).map(([pageCode, page]) => [
            `PAF:${pageCode}`,
            clone(page) as unknown as Record<string, unknown>,
        ]),
    ),
    ...Object.fromEntries(
        Object.entries(PAF_TABLES).map(([pageCode, page]) => [
            `PAF:${pageCode}`,
            clone(page) as unknown as Record<string, unknown>,
        ]),
    ),

    ...Object.fromEntries(
        ALL_APPENDIX_DEFS.flatMap((def) =>
            def.pages.map((pageCode) => {
                const key = `${def.sectionCode}:${pageCode}`;
                if (pageCode === def.pages[0]) {
                    return [key, {title: def.pageTitles[pageCode], rows: clone(def.indexRows)}];
                }
                if (def.summaries[pageCode]) {
                    return [key, clone(def.summaries[pageCode]) as unknown as Record<string, unknown>];
                }
                if (def.programmes[pageCode]) {
                    return [key, clone(def.programmes[pageCode]) as unknown as Record<string, unknown>];
                }
                if (def.tables?.[pageCode]) {
                    return [key, clone(def.tables[pageCode]) as unknown as Record<string, unknown>];
                }
                return [key, {title: def.pageTitles[pageCode]}];
            }),
        ),
    ),
};

export const PROGRAM_TEMPLATE_PAGES: ProgramTemplatePageMeta[] = [
    ...A_SECTION_PAGES.map((pageCode) => ({
        sectionCode: 'A',
        pageCode,
        title: A_PAGE_TITLES[pageCode],
        pageType: (pageCode === 'Ai'
            ? 'special'
            : pageCode === 'A1' ? 'memorandum' : 'checklist') as ProgramTemplatePageMeta['pageType'],
    })),
    ...B_SECTION_PAGES_ALL.map((pageCode) => ({
        sectionCode: 'B',
        pageCode,
        title: B_PAGE_TITLES[pageCode],
        pageType: (pageCode === 'Bi' || ['B6.1', 'B6.2', 'B7'].includes(pageCode)
            ? 'special'
            : pageCode === 'B1'
                ? 'memorandum'
                : 'checklist') as ProgramTemplatePageMeta['pageType'],
    })),
    ...C_SECTION_PAGES.map((pageCode) => ({
        sectionCode: 'C',
        pageCode,
        title: C_PAGE_TITLES[pageCode],
        pageType: (pageCode === 'Ci'
            ? 'special'
            : pageCode === 'C1' || pageCode === 'C1a'
                ? 'memorandum'
                : pageCode in C_CHECKLIST_PAGES
                    ? 'checklist'
                    : 'special') as ProgramTemplatePageMeta['pageType'],
    })),
    ...D_SECTION_PAGES.map((pageCode) => ({
        sectionCode: 'D',
        pageCode,
        title: D_PAGE_TITLES[pageCode],
        pageType: (['D1', 'D2', 'D3', 'D4', 'D5', 'D6', 'D7', 'D8', 'D8.1', 'D10', 'D11', 'D21'].includes(pageCode)
            ? 'checklist'
            : 'special') as ProgramTemplatePageMeta['pageType'],
    })),
    ...E_SECTION_PAGES.map((pageCode) => ({
        sectionCode: 'E',
        pageCode,
        title: E_PAGE_TITLES[pageCode],
        pageType: (pageCode === 'E2' || pageCode === 'Eapp01'
            ? 'checklist'
            : 'special') as ProgramTemplatePageMeta['pageType'],
    })),
    ...F_SECTION_PAGES.map((pageCode) => ({
        sectionCode: 'F',
        pageCode,
        title: F_PAGE_TITLES[pageCode],
        pageType: (pageCode === 'F2' || pageCode === 'Fapp01'
            ? 'checklist'
            : 'special') as ProgramTemplatePageMeta['pageType'],
    })),
    ...G_SECTION_PAGES.map((pageCode) => ({
        sectionCode: 'G',
        pageCode,
        title: G_PAGE_TITLES[pageCode],
        pageType: 'checklist' as ProgramTemplatePageMeta['pageType'],
    })),
    ...H_SECTION_PAGES.map((pageCode) => ({
        sectionCode: 'H',
        pageCode,
        title: H_PAGE_TITLES[pageCode],
        pageType: (pageCode === 'H2'
            ? 'checklist'
            : 'special') as ProgramTemplatePageMeta['pageType'],
    })),
    ...I_SECTION_PAGES.map((pageCode) => ({
        sectionCode: 'I',
        pageCode,
        title: I_PAGE_TITLES[pageCode],
        pageType: (pageCode === 'I2-1' || pageCode === 'I3-1'
            ? 'special'
            : 'checklist') as ProgramTemplatePageMeta['pageType'],
    })),
    ...J_SECTION_PAGES.map((pageCode) => ({
        sectionCode: 'J',
        pageCode,
        title: J_PAGE_TITLES[pageCode],
        pageType: (pageCode === 'J0'
            ? 'checklist'
            : 'special') as ProgramTemplatePageMeta['pageType'],
    })),
    ...K_SECTION_PAGES.map((pageCode) => ({
        sectionCode: 'K',
        pageCode,
        title: K_PAGE_TITLES[pageCode],
        pageType: (pageCode === 'K0'
            ? 'checklist'
            : 'special') as ProgramTemplatePageMeta['pageType'],
    })),
    ...L_SECTION_PAGES.map((pageCode) => ({
        sectionCode: 'L',
        pageCode,
        title: L_PAGE_TITLES[pageCode],
        pageType: (pageCode === 'L2' || pageCode === 'Lapp03'
            ? 'checklist'
            : 'special') as ProgramTemplatePageMeta['pageType'],
    })),
    ...M_SECTION_PAGES.map((pageCode) => ({
        sectionCode: 'M',
        pageCode,
        title: M_PAGE_TITLES[pageCode],
        pageType: (pageCode === 'M2' || pageCode === 'Mapp01'
            ? 'checklist'
            : 'special') as ProgramTemplatePageMeta['pageType'],
    })),
    ...N_SECTION_PAGES.map((pageCode) => ({
        sectionCode: 'N',
        pageCode,
        title: N_PAGE_TITLES[pageCode],
        pageType: 'checklist' as ProgramTemplatePageMeta['pageType'],
    })),
    ...O_SECTION_PAGES.map((pageCode) => ({
        sectionCode: 'O',
        pageCode,
        title: O_PAGE_TITLES[pageCode],
        pageType: (pageCode === 'O0' || pageCode === 'O2'
            ? 'checklist'
            : 'special') as ProgramTemplatePageMeta['pageType'],
    })),
    ...P_SECTION_PAGES.map((pageCode) => ({
        sectionCode: 'P',
        pageCode,
        title: P_PAGE_TITLES[pageCode],
        pageType: (pageCode === 'P0'
            ? 'checklist'
            : 'special') as ProgramTemplatePageMeta['pageType'],
    })),
    ...Q_SECTION_PAGES.map((pageCode) => ({
        sectionCode: 'Q',
        pageCode,
        title: Q_PAGE_TITLES[pageCode],
        pageType: (pageCode === 'Q0'
            ? 'checklist'
            : 'special') as ProgramTemplatePageMeta['pageType'],
    })),
    ...R_SECTION_PAGES.map((pageCode) => ({
        sectionCode: 'R',
        pageCode,
        title: R_PAGE_TITLES[pageCode],
        pageType: (pageCode === 'R0' || pageCode === 'R0.1'
            ? 'checklist'
            : 'special') as ProgramTemplatePageMeta['pageType'],
    })),
    ...S_SECTION_PAGES.map((pageCode) => ({
        sectionCode: 'S',
        pageCode,
        title: S_PAGE_TITLES[pageCode],
        pageType: (pageCode === 'S2'
            ? 'checklist'
            : 'special') as ProgramTemplatePageMeta['pageType'],
    })),
    ...T_SECTION_PAGES.map((pageCode) => ({
        sectionCode: 'T',
        pageCode,
        title: T_PAGE_TITLES[pageCode],
        pageType: (pageCode === 'T2' || pageCode === 'T2-2'
            ? 'checklist'
            : 'special') as ProgramTemplatePageMeta['pageType'],
    })),
    ...V_SECTION_PAGES.map((pageCode) => ({
        sectionCode: 'V',
        pageCode,
        title: V_PAGE_TITLES[pageCode],
        pageType: (pageCode === 'V1'
            ? 'checklist'
            : 'special') as ProgramTemplatePageMeta['pageType'],
    })),
    ...W_SECTION_PAGES.map((pageCode) => ({
        sectionCode: 'W',
        pageCode,
        title: W_PAGE_TITLES[pageCode],
        pageType: (['W2', 'W3', 'W4', 'W5', 'W7'].includes(pageCode)
            ? 'checklist'
            : 'special') as ProgramTemplatePageMeta['pageType'],
    })),
    ...X_SECTION_PAGES.map((pageCode) => ({
        sectionCode: 'X',
        pageCode,
        title: 'Index',
        pageType: 'special' as ProgramTemplatePageMeta['pageType'],
    })),
    ...Y_SECTION_PAGES.map((pageCode) => ({
        sectionCode: 'Y',
        pageCode,
        title: 'Index',
        pageType: 'special' as ProgramTemplatePageMeta['pageType'],
    })),
    ...Z_SECTION_PAGES.map((pageCode) => ({
        sectionCode: 'Z',
        pageCode,
        title: 'Index',
        pageType: 'special' as ProgramTemplatePageMeta['pageType'],
    })),
    ...PAF_SECTION_PAGES.map((pageCode) => ({
        sectionCode: 'PAF',
        pageCode,
        title: PAF_PAGE_TITLES[pageCode],
        pageType: (PAF_PROGRAMMES[pageCode]
            ? 'checklist'
            : 'special') as ProgramTemplatePageMeta['pageType'],
    })),
    ...ALL_APPENDIX_DEFS.flatMap((def) =>
        def.pages.map((pageCode) => ({
            sectionCode: def.sectionCode,
            pageCode,
            title: def.pageTitles[pageCode] ?? pageCode,
            pageType: (def.programmes[pageCode]
                ? 'checklist'
                : 'special') as ProgramTemplatePageMeta['pageType'],
        })),
    ),
];

export function templateKey(sectionCode: string, pageCode: string): string {
    return `${sectionCode}:${pageCode}`;
}

export function getDefaultTemplateContent(sectionCode: string, pageCode: string): Record<string, unknown> | undefined {
    const raw = PROGRAM_TEMPLATE_DEFAULTS[templateKey(sectionCode, pageCode)];
    return raw ? normalizeTemplateContent(clone(raw)) : undefined;
}

export function resolveTemplateContent(
    sectionCode: string,
    pageCode: string,
    fromApi?: Record<string, unknown> | null,
): Record<string, unknown> | undefined {
    if (fromApi && Object.keys(fromApi).length > 0) {
        return normalizeTemplateContent(clone(fromApi));
    }
    return getDefaultTemplateContent(sectionCode, pageCode);
}

export function buildSeedPayload(overwrite = false) {
    return {
        overwrite,
        pages: Object.entries(PROGRAM_TEMPLATE_DEFAULTS).map(([key, content]) => {
            const [sectionCode, pageCode] = key.split(':');
            return {sectionCode, pageCode, content: normalizeTemplateContent(clone(content))};
        }),
    };
}
